import {LookupConfigSpec, LookupSortType} from 'lookup-config/LookupConfigModalConstants';
import {LookupConfig} from 'notebook/structured-tables/StructuredTableConstants';
import {flattenCustomResolutionResults} from 'notebook/tables/string-resolution/flattenCustomResolutionResults';
import {ServerResolutionResult} from 'notebook/tables/string-resolution/StringResolutionConstants';
import * as net from 'util/Net';
import * as TaskRunner from 'util/TaskRunner';

export interface BulkLookupResult {
  serverResolutionResults: Array<ServerResolutionResult>;
}

export interface BulkLookupRequest {
  lookupConfigId: string;
  lookupInputIds: Array<string>;
  lookupSortType?: LookupSortType | null;
}

export function createNotebookLookupConfig(lookupConfigSpec: LookupConfigSpec): Promise<{
  lookupConfig: LookupConfig;
}> {
  return net.postJSONPromise({
    url: '/1/api/eln:create-lookup-config',
    data: {lookupConfigSpec},
  });
}

export function doLookupColumnQuery(
  lookupConfigId: string,
  lookupInputIds: Array<string>,
  lookupSortType?: LookupSortType | null
): Promise<{serverResolutionResults: Array<ServerResolutionResult>}> {
  const results: Promise<{serverResolutionResults: Array<ServerResolutionResult>}> = net.postJSONPromise({
    url: '/1/api/eln:bulk-perform-lookups',
    data: {lookupConfigId, lookupInputIds, lookupSortType},
  });
  return results.then((value) => ({
    serverResolutionResults: flattenCustomResolutionResults(value.serverResolutionResults),
  }));
}

export async function doLookupColumnQueryV2(
  lookupRequests: Array<BulkLookupRequest>
): Promise<Array<BulkLookupResult>> {
  const {responses}: {responses: Array<BulkLookupResult>} = await TaskRunner.postJSONPromise({
    url: '/1/api/eln:bulk-perform-lookups-v2',
    data: {requests: lookupRequests},
  });
  return responses.map((bulkLookupResult) => ({
    ...bulkLookupResult,
    serverResolutionResults: flattenCustomResolutionResults(bulkLookupResult.serverResolutionResults),
  }));
}
